module.exports = vendors_en_1d57cae640a7c4a5fae6;